import type { BuffLayoutSettings } from './types'

/** Icon and time occupy fixed cells; only width/count/preferences affect layout. */
export function buffGridLayout(width: number, count: number, preferred = 32, gap = 8, cellExtra = 0, maxRows = Infinity) {
  const available = Math.max(24, width)
  const spacing = Math.max(0, Math.min(20, gap))
  const total = Math.max(1, count)
  let size = Math.max(24, Math.min(preferred, Math.floor((available - Math.max(0, total - 1) * spacing) / total)))
  let columns = Math.max(1, Math.min(total, Math.floor((available + spacing) / (size + spacing))))
  let rows = Math.ceil(total / columns)
  while (rows > maxRows && size > 18) {
    size -= 1
    columns = Math.max(1, Math.min(total, Math.floor((available + spacing) / (size + spacing))))
    rows = Math.ceil(total / columns)
  }
  return { size, gap: spacing, columns, rows, height: rows * (size + cellExtra) + Math.max(0, rows - 1) * spacing }
}

/** BUFF icons sit in the skin anchor. Saved arrangement no longer splits the window. */
export function buffCompositionLayout(width: number, height: number, count: number, _settings: BuffLayoutSettings, enabledCount = count) {
  const buffs = enabledCount > 0
  const grid = buffGridLayout(Math.max(24, width - 16), Math.max(1, count), 36, 4, 0, 2)
  const extra = buffs ? Math.min(88, grid.height + 12) : 0
  const tier = width < 180 || height < 110 ? 'minimal' : width < 300 || height < 180 ? 'reduced' : width < 480 || height < 260 ? 'compact' : 'full'
  return { buffs, stats: true, horizontal: false, tier, requiredHeight: extra, style: {
    display: 'grid', gridTemplateColumns: 'minmax(0,1fr)', gridTemplateRows: 'minmax(0,1fr)',
  } }
}
